/*
 * @Author: fengxiaojing
 * @LastEditTime: 2022-11-25 14:08:16
 * @Description:
 * @LastEditors: Please set LastEditors
 */
export const NODE_KEY = '$treeNodeId'

// eslint-disable-next-line func-names
export const markNodeData = function (node, data) {
  if (!data || data[NODE_KEY]) return
  Object.defineProperty(data, NODE_KEY, {
    value: node.id,
    enumerable: false,
    configurable: false,
    writable: false,
  })
}

// eslint-disable-next-line func-names
export const getNodeKey = function (key, data) {
  if (!key) return data[NODE_KEY]
  return data[key]
}

export const findNearestComponent = (element, componentName) => {
  let target = element
  while (target && target.tagName !== 'BODY') {
    if (target.__vue__ && target.__vue__.$options.name === componentName) {
      return target.__vue__
    }
    target = target.parentNode
  }
  return null
}
